import { DataProvider } from "react-admin";

// react-admin's UpdateParams type requires `previousData`, but this app's
// own dataProvider.update() (src/dataProvider.ts) never reads it - only
// id/data/meta matter for the PUT request it actually sends. Centralized
// here (like createWithId) so every creator's update call sites don't each
// need their own `previousData: undefined as any`.
export const updateRecord = (
  dataProvider: DataProvider,
  resource: string,
  id: string,
  data: Record<string, any>
) =>
  dataProvider.update(resource, {
    id,
    data,
    previousData: undefined as any,
    meta: { fileUpload: true },
  });
